import { whoIsItFor } from '@/mocks/homeData';

export default function WhoIsItForSection() {
  return (
    <section id="kimler-icin" className="py-16 md:py-24 bg-background-100">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12 md:mb-16">
          <span className="inline-block px-4 py-1.5 bg-accent-100 text-accent-700 rounded-full text-xs font-semibold mb-4">
            Kimler İçin?
          </span>
          <h2 className="font-heading font-bold text-2xl md:text-4xl text-foreground-950 mb-4">
            CiftlikWeb kimler için uygun?
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {whoIsItFor.slice(0, 5).map((item, i) => (
            <div
              key={i}
              className={`bg-background-50 rounded-xl p-6 border border-background-200/70 hover:border-accent-200/50 transition-all duration-300 group ${
                i === 4 ? 'sm:col-span-2 lg:col-span-1 lg:col-start-2' : ''
              }`}
            >
              <div className="w-11 h-11 md:w-12 md:h-12 flex items-center justify-center bg-accent-50 rounded-lg mb-5 group-hover:bg-accent-100 transition-colors duration-300">
                <i className={`${item.icon} text-accent-500 text-xl md:text-2xl`}></i>
              </div>
              <h3 className="font-heading font-semibold text-base md:text-lg text-foreground-950 mb-2.5">
                {item.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {item.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}